import { useParams } from 'react-router-dom';
import moment from 'moment';
import { PlusIcon } from 'lucide-react';
import { useState } from 'react';
import AddCompanyDomainDialog from './AddCompanyDomainDialog';
import { useCompanyDomains } from '@/data/companyDomain';
import { Loading } from '@/components/ui/loading';
import { Error } from '@/components/ui/error';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { mutateListOnPost } from '@/helpers/swr';

const Domains = () => {
  const params = useParams();
  const companyDomains = useCompanyDomains(params.companyUid);
  const [isAddDomainOpen, setIsAddDomainOpen] = useState(false);

  const handleOpenAddDomain = () => {
    setIsAddDomainOpen(true);
  };

  const handleCloseAddDomain = () => {
    setIsAddDomainOpen(false);
  };

  const handleAddDomainSuccess = (newCompanyDomain) => {
    companyDomains.mutate((currentCompanyDomains) => mutateListOnPost(currentCompanyDomains, newCompanyDomain), false);
  };

  if (companyDomains.isLoading && !companyDomains.data) {
    return <Loading />;
  }

  if (companyDomains.error) {
    return <Error message="An error occurred loading company domains" />;
  }
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Domains</h2>
        <Button onClick={handleOpenAddDomain} size="sm">
          <PlusIcon /> Add Domain
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Domain</TableHead>
            <TableHead>Created</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {companyDomains.data.query.map((domainUid) => {
            const domain = companyDomains.data.content[domainUid];
            return (
              <TableRow key={domainUid}>
                <TableCell className="font-medium">{domain.domain}</TableCell>
                <TableCell>{moment(domain.create_ts).format('MMM Do, YYYY')}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {isAddDomainOpen && <AddCompanyDomainDialog onClose={handleCloseAddDomain} companyUid={params.companyUid} onSuccess={handleAddDomainSuccess} />}
    </div>
  );
};

export default Domains;
